import { render, staticRenderFns } from "./NewQueueStep1.vue?vue&type=template&id=3de20021&scoped=true&"
import script from "./NewQueueStep1.vue?vue&type=script&lang=js&"
export * from "./NewQueueStep1.vue?vue&type=script&lang=js&"
import style0 from "./NewQueueStep1.vue?vue&type=style&index=0&id=3de20021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de20021",
  null
  
)

export default component.exports